import React from 'react';
import './App.css';
import Header from './Header';
import GameContainer from './GameContainer';

const App = () => {
  return (
    <div className="App">
      <Header />
      <GameContainer />
    </div>
  );
}

export default App;
